<template>
    <v-dialog v-model="dialog" max-width="500">
        <v-card>
            <v-card-title>Insérer une image</v-card-title>
            <v-card-text>
                <v-text-field v-model="src" label="Entrez l'URL de l'image" outlined></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="applyImage">Appliquer</v-btn>
                <v-btn color="error" @click="closeModal">Annuler</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";

@Component
export default class ImageWindow extends Vue {
    @Prop({ required: true })
    editor!: any;

    @Prop({ default: null })
    attributes!: any;

    @Prop({ default: false })
    isOpen!: boolean;

    dialog = false;
    src = this.attributes?.src || "";

    @Watch("isOpen")
    onIsOpenChange(newVal: boolean) {
        this.dialog = newVal;
    }

    applyImage() {
        if (this.src) {
            this.editor.chain().focus().setImage({ src: this.src }).run();
        }
        this.closeModal();
    }

    closeModal() {
        this.$emit("close");
    }
}
</script>
